import { types } from "../types/types"

 const initState = {
     notes: [],
     active: null
 }
 
 export const notesReducer = (state = initState, action) => {

    switch (action.type) {
        case types.notesSetActive:
            return {
                ...state,
                active: { ...action.payload }
            }

        case types.notesAddNew:
            return {
                ...state,
                notes: [ action.payload, ...state.notes ]
            }

        case types.notesLoad:
            return {
                ...state,
                notes: [ ...action.payload ]
            }

        case types.notesUpdate:
            return {
                ...state,
                notes: state.notes.map(note => 
                    note.id === action.payload.id 
                        ? action.payload.note 
                        : note
                )
            }

        case types.notesDelete:
            return {
                ...state,
                notes: state.notes.filter(note => note.id !== action.payload),
                active: null
            }

        case types.notesCleaning:
            return initState

        default:
            return state
    }
 }